<template>
  <van-loading v-if="loading && isHcpDetails" class="loading">
    {{ brintellixCopy.loading }}
  </van-loading>
  <div v-else class="parting">
    <div>
      <CommonHeader
        v-if="isHcpDetails"
        :title="brintellixCopy.headerTitle"
        icon-url="/lundbeck/NBA/physician.png"
        :no-feedback="true"
      >
        <div slot="before">
          <img
            v-if="!isPhysicianFirst && canEditStatus"
            src="@/assets/lundbeck/NBA/edit.png"
            alt=""
            width="16"
            style="margin-top: 6px"
            @click="openPhysicianDialog()"
          />
        </div>
      </CommonHeader>
      <div v-if="isPhysicianFirst">
        <p class="tip-text">{{ brintellixCopy.tipText }}</p>
        <Button
          v-if="canEditStatus"
          class="tip-button"
          round
          type="info"
          @click="openPhysicianDialog()"
        >
          {{ brintellixCopy.startTyping }}
        </Button>
        <div style="height: 40px;"></div>
      </div>
      <div v-else>
        <div>
          <!-- card -->
          <div class="parting-type">
            <div
              :class="[
                'type-card',
                resultType === '观望者'
                  ? 'parting-type-selected'
                  : 'parting-type-unselected',
              ]"
            >
              <div>
                <div v-if="resultType === '观望者'">
                  <img :src="star" alt="" width="14" />
                </div>
                <p>{{ segmentLabel('观望者') }}</p>
              </div>
            </div>
            <div
              :class="[
                'type-card',
                resultType === '尝试者'
                  ? 'parting-type-selected'
                  : 'parting-type-unselected',
              ]"
            >
              <div>
                <div v-if="resultType === '尝试者'">
                  <img :src="star" alt="" width="14" />
                </div>
                <p>{{ segmentLabel('尝试者') }}</p>
              </div>
            </div>
            <div
              :class="[
                'type-card',
                resultType === '倡导者'
                  ? 'parting-type-selected'
                  : 'parting-type-unselected',
              ]"
            >
              <div>
                <div v-if="resultType === '倡导者'">
                  <img :src="star" alt="" width="14" />
                </div>
                <p>{{ segmentLabel('倡导者') }}</p>
              </div>
            </div>
          </div>
          <img src="@/assets/svg/xAxis.svg" alt="" style="width: 340px; margin-top: 10px;" />
        </div>

        <!-- 当前分型详情 -->
        <div class="parting-type-action">
          <div>
            <template v-if="resultType && localizedSegmentDetails[resultType]">
              <div v-for="(section, sectionIndex) in localizedSegmentDetails[resultType]" :key="sectionIndex" class="action-plan">
                <template v-for="(content, title) in section">
                  <div :key="title">
                    <div class="action-title">
                      <div class="title-flag"></div>
                      <span class="title-text">{{ title }}</span>
                    </div>
                    <div class="action-plan">
                      <template v-if="Array.isArray(content)">
                        <p v-for="(text, index) in content" :key="index" class="action-text">
                          <span class="action-flag"></span>
                          <span v-html="highlightText(text)"></span>
                        </p>
                      </template>
                      <template v-else>
                        <p class="action-text">
                          <span v-html="highlightText(content)"></span>
                        </p>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>

        <!-- EDA -->
        <div v-if="false" class="parting-type-action">
          <div class="action-plan">
            <div class="action-title">
              <div class="title-flag"></div>
              <span class="title-text">相关资料</span>
            </div>
            <div class="eda-content action-plan">
              <p
                v-for="(eda, idx) in edas[resultType] || []"
                :key="eda.title + idx"
                class="action-text flex"
              >
                <span class="flex-1">
                  <span class="action-flag"></span>
                  <span>{{ eda.title }}</span>
                  <span class="key-message-labels" style="display: block;">
                    <span v-for="(tag, tagIdx) in eda.tags" :key="tagIdx">{{ tag }}</span>
                  </span>
                </span>
                <span>
                  <img
                    src="@/assets/lundbeck/NBA/preview.png"
                    alt=""
                    width="26"
                    style="margin-left: 4px;"
                    @click="previewImage(eda.file || '')"
                  />
                </span>
              </p>
            </div>
          </div>
        </div>

        <!-- 模拟演练 Roleplay -->
        <div v-if="false && isHcpDetails" class="roleplay-section nba-pannel">
          <p class="nba-title">模拟场景演练</p>
          <div class="custom-select" @click="showRoleplayPicker = true">
            <span class="label">
              <span class="roleplay-avatar">
                <img
                  src="@/assets/lundbeck/roleplay-hcp.png"
                  style="display:block;"
                />
              </span>
            </span>
            <span v-if="selectedRoleplay" class="value">{{ selectedRoleplay }}</span>
            <span v-else class="placeholder">请选择场景</span>
            <van-icon name="arrow-down" class="select-arrow" />
          </div>
          <van-popup v-model="showRoleplayPicker" position="bottom" round>
            <div style="max-height: 60vh; overflow-y: auto; padding: 16px;">
              <van-radio-group v-model="tempRoleplay">
                <van-radio
                  v-for="scene in roleplayScenes"
                  :key="scene"
                  :name="scene"
                  style="white-space: normal; line-height: 1.5; margin-bottom: 16px;"
                >
                  {{ scene }}
                </van-radio>
              </van-radio-group>
              <div style="text-align:right;margin-top:16px;">
                <van-button size="small" @click="showRoleplayPicker = false">取消</van-button>
                <van-button size="small" type="primary" style="margin-left:8px" @click="onRoleplayConfirm(tempRoleplay)">确定</van-button>
              </div>
            </div>
          </van-popup>
          <div v-if="selectedRoleplay" class="roleplay-speech">
            <div class="speech-title">推荐话术</div>
            <div class="custom-select">
              <span class="value">
                <template v-if="Array.isArray(roleplaySpeech[selectedRoleplay]) && roleplaySpeech[selectedRoleplay].length > 1">
                  <ol>
                    <li v-for="(item, idx) in roleplaySpeech[selectedRoleplay]" :key="idx">{{ item }}</li>
                  </ol>
                </template>
                <template v-else>
                  {{ Array.isArray(roleplaySpeech[selectedRoleplay]) ? roleplaySpeech[selectedRoleplay][0] : roleplaySpeech[selectedRoleplay] }}
                </template>
              </span>
              <span class="label">
                <span class="roleplay-avatar">
                  <img
                    src="@/assets/lundbeck/roleplay-mr.png"
                    style="display:block;"
                  />
                </span>
              </span>
            </div>
          </div>
          <div class="flex" style="align-items: center;">
            <div style="width: 33%"></div>
            <div class="roleplay-ai-link" style="width: 33%">跳转到AI陪练</div>
            <div style="width: 33%; font-size: 12px;">评估总分：<span style="color: #aa341b; font-size: 16px;">98</span></div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <PhysicianTypingDialog
        :show="physicianDialogShow"
        :physician-id="nbaPhysicianId"
        :product-id="productId"
        :initial-answers="questionAnswers"
        @update:show="physicianDialogShow = $event"
        @close="physicianDialogShow = false"
        @finish="onTypingFinish"
      />
    </div>
    <swipeDialog
      v-if="pdfLink"
      :backtxt="$t('back')"
      :title="brintellixCopy.previewTitle"
      @closeFn="closePdfFn"
    >
      <pdf v-if="pdfLink" :src="pdfLink" />
    </swipeDialog>

  </div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader';
import {Button, RadioGroup, Radio, Loading, ImagePreview, Field, Popup, Picker, Icon} from 'vant';
import * as py from '@/api/Physicians';
import * as contentApi from '@/api/content';
import {getLocalStorage} from '@/utils';
import pdf from 'vue-pdf';
import swipeDialog from '@/views/layout/swipeDialog';
import TaskList from './TaskList.vue';
import {wecomSDK} from '@/utils/wecom';
import PhysicianTypingDialog from './BrintellixTypingDialog.vue';
import * as moment from 'moment';
import { getPhysicianTasks, executeTask } from '@/api/nba';
import { BRINTELLIX_COPY } from './brintellixCopy';

export default {
  name: 'Azilect',
  components: {
    CommonHeader,
    Button,
    vanRadioGroup: RadioGroup,
    vanRadio: Radio,
    swipeDialog,
    vanLoading: Loading,
    pdf,
    // TaskList,
    // vanField: Field,
    vanPopup: Popup,
    vanButton: Button,
    vanIcon: Icon,
    // vanPicker: Picker,
    PhysicianTypingDialog,
  },
  props: {
    physicianId: String,
    productId: {
      type: String,
      default() {
        return '';
      },
    },
    showActions: {
      type: Boolean,
      default() {
        return true;
      },
    },
    showOfflineActions: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      loading: false,
      isPhysicianFirst: true,
      physicianDialogShow: false,
      questionAnswers: [],
      physicianPartings: [],
      physicianAnswerTips: false,
      physicianSelectedParting: '',
      star: require('@/assets/lundbeck/star.png'),
      showType: '',
      numPages: 0,
      pdfLink: '',
      pdfKey: '',
      detailStatus: false,
      fileLoading: false,
      canEditStatus: true,
      resultType: '',
      campaigns: {
        '观望者': [
          {
            'title': '心悦领航',
          },
          {
            'title': '大师班',
          },
          {
            'title': '指南巡讲',
          },
        ],
        '尝试者': [
          {
            'title': '心悦领航',
          },
          {
            'title': '大师班',
          },
          {
            'title': '指南巡讲',
          },
        ],
        '倡导者': [
          {
            'title': '心悦领航',
          },
          {
            'title': '大师班',
          },
          {
            'title': '指南巡讲',
          },
        ],
      },
      edas: {
        '观望者': [
          {
            'title': 'CANMAT指南更新要点解读',
            'tags': ['eDetailing', '指南'],
            'file': 'CNCT-002756/Slide1.png,CNCT-002756/Slide2.png,CNCT-002756/Slide3.png,CNCT-002756/Slide4.png,CNCT-002756/Slide5.png,' +
              'CNCT-002756/Slide6.png,CNCT-002756/Slide7.png,CNCT-002756/Slide8.png,CNCT-002756/Slide9.png,CNCT-002756/Slide10.png',
          },
          {
            'title': '基于指南的抑郁症规范化诊疗',
            'tags': ['eDatailing', '指南'],
          },
          {
            'title': '从指南更新，看功能恢复目标下的药物选择',
            'tags': ['eDatailing', '指南'],
          },
          {
            'title': '抗抑郁药物机制最新进展',
            'tags': ['eDatailing', '前沿进展'],
          },
          {
            'title': '2024-2025抑郁领域进展大事记',
            'tags': ['eDatailing', '前沿进展'],
          },
        ],
        '尝试者': [
          {
            'title': 'CANMAT指南更新要点解读',
            'tags': ['eDetailing', '指南'],
            'file': 'CNCT-002756/Slide1.png,CNCT-002756/Slide2.png,CNCT-002756/Slide3.png,CNCT-002756/Slide4.png,CNCT-002756/Slide5.png,' +
              'CNCT-002756/Slide6.png,CNCT-002756/Slide7.png,CNCT-002756/Slide8.png,CNCT-002756/Slide9.png,CNCT-002756/Slide10.png',
          },
          {
            'title': '基于指南的抑郁症规范化诊疗',
            'tags': ['eDatailing', '指南'],
          },
          {
            'title': '从指南更新，看功能恢复目标下的药物选择',
            'tags': ['eDatailing', '指南'],
          },
          {
            'title': '抗抑郁药物机制最新进展 ',
            'tags': ['eDatailing', '前沿进展'],
          },
          {
            'title': '2024-2025抑郁领域进展大事记',
            'tags': ['eDatailing', '前沿进展'],
          },
        ],
        '倡导者': [
          {
            'title': 'CANMAT指南更新要点解读',
            'tags': ['eDetailing', '指南'],
            'file': 'CNCT-002756/Slide1.png,CNCT-002756/Slide2.png,CNCT-002756/Slide3.png,CNCT-002756/Slide4.png,CNCT-002756/Slide5.png,' +
              'CNCT-002756/Slide6.png,CNCT-002756/Slide7.png,CNCT-002756/Slide8.png,CNCT-002756/Slide9.png,CNCT-002756/Slide10.png',
          },
          {
            'title': '基于指南的抑郁症规范化诊疗',
            'tags': ['eDatailing', '指南'],
          },
          {
            'title': '从指南更新，看功能恢复目标下的药物选择',
            'tags': ['eDatailing', '指南'],
          },
          {
            'title': '抗抑郁药物机制最新进展 ',
            'tags': ['eDatailing', '前沿进展'],
          },
          {
            'title': '2024-2025抑郁领域进展大事记',
            'tags': ['eDatailing', '前沿进展'],
          },
        ],
      },
      tasks: [
        // {
        //   type: '推文',
        //   time: '4月18日',
        //   campaign: '2025抑郁症大师班系列',
        //   title: '如何破解抑郁症快感缺失难题？全球专家深度对话',
        //   hcp_name: '胡琦',
        //   segment: '观望者',
        //   target: '推荐心达悦/伏硫西汀中标品20mg',
        //   km: '认知改善也很重要，独立于情绪改善',
        //   isWechat: true,
        //   content_id: 'content-live-mdd-20250617-live-highlight',
        // },
        // {
        //   type: '直播',
        //   time: '3月14日 14:00',
        //   campaign: '2025抑郁症大师班系列',
        //   title: '2025年抑郁症大师班系列 第一期',
        //   hcp_name: '陈博',
        //   thumb: 'https://hcp360-mobile.lundbecksys.cn/api/aws/S3/GetFile?bucketName=pim-prod&key=live/live-mdd-20250617/live-mdd-20250617-banner.jpg',
        //   segment: '观望者',
        //   target: '推荐心达悦/伏硫西汀中标品20mg',
        //   km: '认知改善也很重要，独立于情绪改善',
        //   content_id: 'content-live-mdd-20250617-live-highlight',
        // },
      ],
      showRoleplayPicker: false,
      selectedRoleplay: '',
      tempRoleplay: '',
      roleplayScenes: [
        '关注患者的情绪和躯体症状，认为情绪症状改善后，认知症状也会有所改善；',
        '常使用SSRI和SNRI类药物，如舍曲林、艾司西酞普兰，文拉法辛，度洛西汀，认可其控制抑郁情绪的疗效，认为抑郁患者把情感症状控制住非常重要，对伴有明显躯体症状的患者会使用SNRI，如度洛西汀；',
        '刚开始尝试心达悦，使用经验不丰富，认为其对于抑郁症状改善效果与其他抗抑郁药疗效差不多。',
      ],
      roleplaySpeech: {
        '关注患者的情绪和躯体症状，认为情绪症状改善后，认知症状也会有所改善；': '展示伏硫西汀的相关研究数据，展示心达悦（伏硫西汀）在改善情绪低落相关症状上的疗效，在接下来的门诊中，王医生能够选择在使用SSRI类药物治疗后情绪改善仍然不佳的患者，可以尝试调整治疗方案，使用心达悦或者伏硫西汀中标品来进行治疗。',
        '常使用SSRI和SNRI类药物，如舍曲林、艾司西酞普兰，文拉法辛，度洛西汀，认可其控制抑郁情绪的疗效，认为抑郁患者把情感症状控制住非常重要，对伴有明显躯体症状的患者会使用SNRI，如度洛西汀；': '展示伏硫西汀的相关研究数据，展示心达悦（伏硫西汀）在改善情绪低落相关症状上的疗效，在接下来的门诊中，王医生能够选择在使用SSRI类药物治疗后情绪改善仍然不佳的患者，可以尝试调整治疗方案，使用心达悦或者伏硫西汀中标品来进行治疗。',
        '刚开始尝试心达悦，使用经验不丰富，认为其对于抑郁症状改善效果与其他抗抑郁药疗效差不多。': '展示伏硫西汀的相关研究数据，展示心达悦（伏硫西汀）在改善情绪低落相关症状上的疗效，在接下来的门诊中，王医生能够选择在使用SSRI类药物治疗后情绪改善仍然不佳的患者，可以尝试调整治疗方案，使用心达悦或者伏硫西汀中标品来进行治疗。',
      },
      visitTarget: 7,
      visitDone: 0,
    };
  },
  computed: {
    nbaPhysicianId() {
      return this.physicianId ?? this.$route.query.physician_id;
    },
    isHcpDetails() {
      return !this.physicianId;
    },
    localeKey() {
      const locale = (this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh').toLowerCase();
      return locale.indexOf('en') === 0 ? 'en' : 'zh';
    },
    brintellixCopy() {
      return BRINTELLIX_COPY[this.localeKey];
    },
    localizedSegmentDetails() {
      return this.brintellixCopy.segmentDetails;
    },
  },
  mounted() {
    if (getLocalStorage('territory_type') === 'MR') {
      this.canEditStatus = true;
    }
    this.getPhysicianTyping();
    // wecomSDK.register();
  },
  methods: {
    getPhysicianTyping() {
      this.loading = true;
      let params = {
        physician_id: this.nbaPhysicianId,
        product_id: this.productId,
        territory_id: getLocalStorage('territory_id'),
      };
      py.getPhysicianTyping(params).then((res) => {
        if (res && res.value.length) {
          this.physicianPartings = res.value;

          if (this.physicianPartings.length > 0) {
            this.isPhysicianFirst = false;
            this.questionAnswers = JSON.parse(
              this.physicianPartings[0].content,
            );
            this.resultType = this.physicianPartings[0].result;
          } else {
            this.isPhysicianFirst = true;
          }
        }
        this.loading = false;
      });
    },
    openPhysicianDialog() {
      this.physicianDialogShow = true;
    },
    beforePhysicianClose(action, done) {
      if (action === 'confirm' && this.physicianDialogShow) {
        done(false);
      } else {
        done();
      }
    },
    closeDiglog() {
      this.physicianDialogShow = false;
    },
    previewImage(slides) {
      const endpoint = 'https://hcp360-mobile.lundbecksys.cn/api/aws/S3/GetFile?bucketName=lundbeck-superrep-hcp360-prod&key=LFile/nba/brintellix/key-message/';
      console.log(slides);
      if (slides.indexOf('.pdf') > 0) {
        this.lookPdfDetail(endpoint + slides);
      } else {
        let images = [];
        slides.split(',').forEach((image) => {
          images.push(endpoint + image);
        });
        ImagePreview({
          images: images,
          loop: false,
          showIndicators: true,
        });
      }
    },
    lookPdfDetail(url) {
      this.$store.dispatch('setDialogStatus', true);
      this.detailStatus = true;
      this.pdfLink = url;
    },
    closePdfFn() {
      this.$store.dispatch('setDialogStatus', false);
      this.pdfLink = null;
    },
    closeFn() {
      this.$store.dispatch('setDialogStatus', false);
      this.detailStatus = false;
      this.pdfLink = null;
      this.pdfKey = null;
    },
    segmentLabel(type) {
      return this.brintellixCopy.segmentLabels[type] || type;
    },
    highlightText(text) {
      // 将文本中的关键信息用highlight class标记
      return text.replace(/【(.+?)】/g, '<span class="highlight">$1</span>');
    },
    sendTask(task) {
      const toast = this.$createToast({
        time: 10000,
        mask: false,
      });
      // 显示加载提示
      toast.show();
      // 处理发送任务的逻辑
      contentApi.getContentById(task.content_id).then((res) => {
        if (res && res.value && res.value.length > 0) {
          const forwardContent = res.value[0];

          try {
            wecomSDK.shareWechatMessage({
              content_id: task.content_id,
              sender_user_id: getLocalStorage('user_id'),
              sender_user_name: getLocalStorage('user_name'),
              sender_territory_id: getLocalStorage('territory_id'),
              receiver_physician_id: this.nbaPhysicianId,
              send_time: new Date(),
              title: forwardContent.content_name,
              description: forwardContent.description,
              wx_logo: forwardContent.wx_logo,
            });

            console.log('Send task:', task);
            toast.hide();
          } catch (err) {
            toast.hide();
            console.error('Forward error:', err);
            this.$toast.fail(this.brintellixCopy.forwardFailed);
          }
        } else {
          toast.hide();
        }
      });
    },
    ignoreTask(task) {
      // 处理忽略任务的逻辑
      console.log('Ignore task:', task);
    },
    onRoleplayConfirm(val) {
      this.selectedRoleplay = val;
      this.showRoleplayPicker = false;
    },
    goToVisit() {
      // 跳转到拜访页面
      this.$router.push({ path: '/hcp/visit-create', query: { physician_id: this.nbaPhysicianId } });
    },
    async onTypingFinish() {
      this.getPhysicianTyping();

      // 查询医生任务并自动执行Brintellix segment任务
      try {
        const res = await getPhysicianTasks(
          this.nbaPhysicianId,
          getLocalStorage('user_id'),
          this.productId,
          false, // 只查未执行任务
          1,
          50
        );
        if (res && res.data && res.data.length > 0) {
          const segmentTask = res.data.find(
            t =>
              t.event_type === 'segment' &&
              t.product_id === this.productId &&
              t.execution_type === null
          );
          if (segmentTask) {
            await executeTask(
              'accept',
              segmentTask.campaign_event_id,
              segmentTask.physician_id,
              getLocalStorage('user_id'),
              localStorage.getItem('user_name') || '',
              localStorage.getItem('territory_id') || '',
              getLocalStorage('role_id') || ''
            );
            this.$toast(this.brintellixCopy.segmentTaskExecuted);
            this.$root.$emit('updateTaskCount');
            this.$emit('refreshTasks');
          }
        }
      } catch (err) {
        this.$toast(this.brintellixCopy.segmentTaskExecutionFailed);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.parting {
  .tip-text {
    font-size: 14px;
    font-family: Arial;
    font-weight: 400;
    color: #2c3034;
    opacity: 1;
    margin: 40px auto 20px;
  }
  .tip-button {
    width: 160px;
    height: 40px;
    background: #aa341b;
    border: 1px solid #aa341b;
    opacity: 1;
    border-radius: 500px;
    margin-bottom: 20px;
  }
  .diglog-close {
    position: absolute;
    font-size: 30px;
    top: 25px;
    right: 20px;
  }
  .parting-type {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    font-size: 15px;
    .parting-type-unselected {
      width: 98px;
      height: 80px;
      background: linear-gradient(46deg, #f8f6f5 0%, #f3e6e3 100%);
      opacity: 1;
      border-radius: 4px;
      margin: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        width: 50px;
        line-height: 1.5;
        color: #aa341b;
      }
    }
    .parting-type-selected {
      display: flex;
      align-items: center;
      width: 98px;
      height: 100px;
      background: linear-gradient(46deg, #aa341b 0%, #aa341b 100%);
      opacity: 1;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        width: 50px;
        line-height: 1.5;
        color: #ffffff;
      }
    }
  }
  .parting-type-x {
    display: flex;
    justify-content: space-around;
    color: #838a95;
    p {
      display: inline-block;
    }
  }

  .title-flag {
    width: 6px;
    height: 12px;
    background: #aa341b;
    opacity: 1;
    border-radius: 4px;
  }
  .title-text {
    height: 22px;
    font-size: 14px;
    font-family: Arial;
    font-weight: 700;
    color: #2c3034;
    opacity: 1;
    margin-left: 5px;
  }
  .parting-type-action {
    margin-top: 2px;
  }
  .action-title {
    display: flex;
    align-items: baseline;
    height: 20px;
  }
  .action-plan {
    padding: 10px 10px;
  }
  .action-flag {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #aa341b;
    opacity: 1;
    border-radius: 4px;
    margin: 0 5px 2px 0;
  }
  .action-text {
    font-size: 14px;
    font-family: Arial;
    font-weight: 400;
    color: #2c3034;
    opacity: 1;
    text-align: left;
    line-height: 1.3;
    margin-bottom: 10px;
  }
  .key-message-content-type > span {
    background: rgba(236, 233, 223, 0.5);
    border-radius: 20px;
    font-size: 11px;
    color: #333;
    white-space: nowrap;
    padding: 3px 8px;
    margin: 0 2px 0 0;
  }
  .key-message-labels > span {
    background: rgba(236, 233, 223, 0.5);
    border-radius: 20px;
    font-size: 11px;
    color: #333;
    white-space: nowrap;
    padding: 3px 8px;
    margin: 0 2px 0 0;
  }
  .action-highlight {
    font-size: 15px;
    font-family: Arial;
    font-weight: 700;
    color: #aa341b;
    opacity: 1;
    text-align: left;
    line-height: 1.2;
    margin-bottom: 15px;
    .action-flag {
      background: #aaa;
    }
    span {
      font-weight: 700;
    }
  }
  .bold {
    font-weight: 700;
    span {
      font-weight: 700;
    }
  }
  .action-tag {
    color: #ab351c;
  }
  .highlight {
    color: #aa341b;
  }
  .action-progress {
    display: flex;
    align-items: center;
    height: 30px;
    background: rgba(236, 233, 223, 0.5);
    border-radius: 4px;
    margin-bottom: 20px;
    p {
      color: #aa341b;
      font-size: 14px;
      font-family: Arial;
      font-weight: 700;
      margin-left: 10px;
    }
  }
  .download {
    z-index: 1;
    position: absolute;
    top: 450px;
    right: 20px;
    border: 1px solid rgb(218, 217, 217);
    border-radius: 100%;
    padding: 5px;
  }
  .proof-link {
    h4 {
      font-size: 14px;
      font-family: Arial;
      font-weight: bold;
      color: #2c3034;
      margin: 10px 0 20px;
      padding: 0;
    }
  }
}
.loading {
  margin-top: 55%;
}
.reject-box {
  width: 50vw;
  padding: 15px;

  .reject-prompt {
    font-size: 14px;
    color: #666;
  }
  .answer {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin: 10px;
    ::v-deep .van-checkbox__label,
    ::v-deep .van-radio__label {
      font-size: 14px;
      text-align: left;
      margin: 4px;
    }
  }
  .reject-button {
    width: 150px;
    height: 36px;
    opacity: 1;
    border-radius: 500px;
    margin: 20px auto;
    display: block;
  }
  .textarea {
    width: 100%;
    padding: 5px;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 15px;
    color: #666;
  }
}
.nba-pannel {
  margin: -10px 0 -2px 0;
  padding: 8px;
  background-color: #f8f6f2;
  border-radius: 0 0 10px 10px;
  .nba-title {
    padding: 2px 0 10px 0;
    margin: 0;
    font-size: 12px;
    display: block;
    font-weight: 700;
    color: #aa341b;
    text-align: center;
  }
  .action-text {
    padding: 10px;
    margin-bottom: 8px;
    border-radius: 8px;
    background-color: #ffffff;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.van-cell {
  padding: 0;
}
.van-radio {
  margin-bottom: 5px;
}
::v-deep .van-radio__label {
  text-align: left;
  font-size: 14px;
}
.roleplay-section {
  margin: 0 8px 40px 8px;
  border-radius: 10px;

  .custom-select {
    display: flex;
    align-items: center;
    min-height: 44px;
    padding: 8px 4px;
    cursor: pointer;
    .label {
      color: #888;
      flex-shrink: 0;
    }
    .value, .placeholder {
      flex: 1;
      white-space: normal;
      word-break: break-all;
      background: #fff;
      border-radius: 8px;
      padding: 10px 14px;
      color: #222;
      font-size: 14px;
      text-align: left;
      line-height: 1.2;
    }
    .placeholder {
      color: #bbb;
    }
    .select-arrow {
      margin-left: 8px;
      color: #bbb;
      font-size: 18px;
      flex-shrink: 0;
    }
  }
  .speech-title {
    font-weight: bold;
    margin: 12px 0 4px 0;
    color: #aa341b;
  }
  ol {
    text-align: left;;
    padding-left: 15px;
    margin: 0;
    list-style: decimal;
    li {
      font-size: 14px;
      color: #2c3034;
      margin-bottom: 6px;
      line-height: 1.2;
      list-style: decimal;
    }
  }
  .roleplay-avatar {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: #fbeee3;
    border-radius: 50%;
    margin-right: 8px;
    img {
      height: 48px;
    }
  }
  .roleplay-ai-link {
    margin: 10px auto;
    background: #fff;
    padding: 8px 8px;
    color: #aa341b;
    border-radius: 40px;
    border: 1px solid #aa341b;
    text-align: center;
    font-size: 14px;
    width: 120px;
  }
}
.visit-kpi-box {
  .visit-kpi-title {
    color: #aa341b;
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .visit-kpi-row {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 10px 20px;
    margin-bottom: 18px;
    border-radius: 8px;
    background-color: #ffffff;
  }
  .visit-kpi-item {
    flex: 0 0 auto;
    .visit-kpi-label {
      color: #888;
      font-size: 13px;
      margin-bottom: 2px;
    }
    .visit-kpi-value {
      color: #2c3034;
      font-size: 18px;
      font-weight: bold;
    }
  }
  .visit-kpi-btn {
    margin-left: auto;
    background: #aa341b;
    border-radius: 20px;
    font-size: 14px;
    padding: 0 18px;
    height: 32px;
    line-height: 32px;
    border: none;
  }
}</style>
